import { render, staticRenderFns } from "./DisciplinaryLogDetail.vue?vue&type=template&id=4aafecaa&scoped=true&"
import script from "./DisciplinaryLogDetail.vue?vue&type=script&lang=js&"
export * from "./DisciplinaryLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aafecaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
